import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdatesAPI, StatusUpdateState } from 'api/status-updates';
import { createStatusUpdate, CreateStatusUpdatesPayload } from '../actions';
import { appendStatusUpdate } from '../slice';

function* createStatusUpdateManager(
  action: PayloadAction<CreateStatusUpdatesPayload>,
) {
  const { payload } = action;

  const statusUpdate = {
    statusUpdateTitle: payload.title,
    collaborators: payload.collaborators,
    state: StatusUpdateState.Draft,
    toUsers: payload.toUsers,
    project: {
      projectId: payload.projectId,
    },
    private: !!payload.private,
    source: payload.source,
  };

  try {
    const response = yield StatusUpdatesAPI.createStatusUpdate(statusUpdate);

    yield put(appendStatusUpdate(response));
    yield payload.onSuccess && payload.onSuccess(response);
  } catch {
    // TODO
  }
}
export const watchCreateStatusUpdates = function* () {
  yield takeLatest(createStatusUpdate.type, createStatusUpdateManager);
};
